import React, { FC } from 'react';
import useNativeChangeTitle from 'SRC/common/hooks/useNativeChangeTitle';
import styles from './styles.scss';
interface IBaseProps {}
const PrivacyPolicies: FC<IBaseProps> = () => {
  useNativeChangeTitle('纳米盒隐私政策简明版', '');
  return (
    <div className={styles['policies-wrap']}>
      <h1>纳米盒隐私政策简明版</h1>
      <p style={{ textIndent: '2em' }}>
        我们深知个人信息安全与隐私保护非常重要，本指引将帮助您直观、简明地了解我们是如何收集、处理使用个人信息以及如何保护您的隐私。
      </p>
      <h3>1、我们如何收集、使用信息</h3>
      <p style={{ textIndent: '2em' }}>
        我们会在向你提供服务过程中使用你主动提供的，以及经过你的授权通过自动化手段收集的下列信息：
      </p>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>个人身份与联系方式</h5>
        <p>
          <strong>注册登录：</strong>我们需要通过手机号进行账户注册、登录。
        </p>

        <p>
          <strong>与您联系：</strong>
          我们可能通过手机号码向您发生运营、推广、活动等信息，您可以拒绝或退订我们或运营方发送的上述信息。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>地理位置</h5>
        <p>
          <strong>概要：</strong>
          GPS等精准位置信息需要您额外单独授权，同时WLAN接入点、蓝牙、基站以及IP地址等信息也可以描述设备所在的大致位置。
        </p>

        <p>
          <strong>使用目的：</strong>
          <br />
          （1）在App首次启动时或您手动进入地区切换时，我们使用位置信息帮您快速定位到您所在的城市，为你推荐当前地区配套的点读课本，例如定位到您所在的地区为上海，则为您展示沪教的书本。
          <br />
          （2）当您新增或修改收货地址时，我们会根据使用位置信息快速显示当前所在的城市，方便您快速填写收货地址。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>摄像头</h5>
        <p>
          <strong>概要：</strong>
          摄像头为敏感权限，我们只在您需要扫码、拍照等功能时开启。
        </p>
        <p>
          <strong>特别说明：</strong>
          我们不会私自开启摄像头窃取您的隐私，更不会采用此种非法手段进行信息、广告推送。
        </p>

        <p>
          <strong>使用目的：</strong>
          <br />
          （1）在您使用App扫码查看答案解析时，我们需要使用您的摄像头识别二维码。
          <br />
          （2）当您上传图片作品时，我们需要使用您的摄像头进行拍照。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>麦克风</h5>
        <p>
          <strong>概要：</strong>
          麦克风为敏感权限，我们只在您进行口语评测时开启。
        </p>
        <p>
          <strong>特别说明：</strong>
          我们不会私自开启麦克风窃取您的隐私，更不会采用此种非法手段进行信息、广告推送。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>剪切板</h5>
        <p>
          <strong>使用目的：</strong>
          <br />
          （1）通过微信等分享回流方式参与活动时，我们会对剪切板中是否符合活动规则的信息再本地进行判断。
          <br />
          （2）通过微信、小程序等跳转到App时，可能会通过剪切板将用户浏览行为同步到App上继续无缝衔接使用。
        </p>
        <p>
          <strong>特别说明：</strong>
          我们在读取剪切板时，只本地分析符合我们特殊定义格式的信息，对不符合特殊格式的信息我们不会进行分析，也不会同步到服务器。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>设备信息</h5>
        <p>
          <strong>概要：</strong>
          设备信息是指设备标识符、网络接入信息、设备传感器等等，设备信息在手机终端中可能被表述为“电话信息”，这不代表App会收集通讯内容或您主动输入的隐私信息。
        </p>
        <p>
          <strong>使用目的：</strong>
          设备标识信息对于用户绑定设备号的统计具有不可替代的作用。设备信息也通常用在反作弊和判断账号是否处理安全环境中，例如：微信或支付宝支付时判断支付环境是否安全。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>存储空间</h5>
        <p>
          <strong>概要：</strong>
          存储空间权限时指提供写入外部存储功能，允许写入、读取、删除存储空间及相片的权限。
        </p>
        <p>
          <strong>使用目的：</strong>
          我们会申请存储权限，用于您保存一些图片到本地相册，或您在主动选择相册中的照片用于二维码识别或上传您的个人头像或您的作品。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>陀螺仪、加速度、重力传感器</h5>
        <p>
          <strong>概要：</strong>
          调用设备的陀螺仪、加速度、重力传感器以识别判断您当前设备的屏幕朝向，自动布局当前页面展示，为用户提供更好的横竖屏使用体验。
        </p>
        <p>
          <strong>使用目的：</strong>
          在阅读书本时，检测设备屏幕方向变化，用于横竖屏布局显示，以便为用户提供更加合适的阅读体验。
        </p>
      </section>

      <h3>2、如何更好地控制个人信息的使用</h3>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>隐私权限撤销</h5>
        <p>
          <strong>概要：</strong>
          您可前往隐私权限设置界面
          <strong>（账户/未登录-设置-系统设置-隐私权限设置）</strong>
          ，开启或撤销对应权限访问
        </p>
        <p>
          <strong>特别说明：</strong>
          关闭对应权限后涉及对应权限的功能可能会产品影响或不能正常使用，例如关闭麦克风权限后，您将无法进行语音评测。
        </p>
      </section>

      {/* panel */}
      <section className={styles['panel']}>
        <h5>账号注销</h5>
        <p>
          <strong>概要：</strong>
          如您已注册登录，可前往注销账号界面
          <strong>（账户/未登录-设置-系统设置-注销）</strong>
          ，向客服申请注销账号。
        </p>
        <p>
          <strong>特别说明：</strong>
          账号注销前请确保您的账号已经清空（包括红包、金币、优惠券等），一旦注销您的账号信息及该账号信息产生的数据将被删除且不可恢复。
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicies;
